import http, { url } from '../http'

const API_URL = "copass_appointed"

class CopassConformationActAPI {

  async createCopassConformationAct(copassConformationAct) {
    const response = await http(`${API_URL}/save`, 'POST', copassConformationAct)
    return response
  }

  async getConformationActByCompany(companyId) {
    const response = await http(`${API_URL}/companies/${companyId}`, 'GET')
    return response.copass_appointed.data || []
  }

  async getConformationActCompany(companyId) {
    const response = await http(`${API_URL}/all/${companyId}`, 'GET')
    return response
  }
  
  async get(copasstID) {
    const response = await http(`${API_URL}/${copasstID}`, 'GET')
    return response
  }

  getConformationAct(employeeId) {
    return url(`${API_URL}/downloadpdf/${employeeId}.pdf`)
  }

  async update(copasstID, copasst) {
    const response = await http(`${API_URL}/update/${copasstID}`, 'PUT', copasst)
    return response
  }

  async saveEvidence(vigia) {
    const response = await http(`${API_URL}/vigia`, 'POST', vigia)
    return response
  }

  // Acta de Asignación de Vigía branded: la app genera el PDF y el encargado firma
  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

}

export default new CopassConformationActAPI()